/**
 * Given an ISO date string (YYYY-MM-DD), returns a friendly age string like
 * "3 years 2 months", "11 months", or "" if invalid/empty.
 * Pure function so it can be used by any page.
 */
export function ageFromBirthday(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  if (d > now) return 'Not born yet';
  let years = now.getFullYear() - d.getFullYear();
  let months = now.getMonth() - d.getMonth();
  if (now.getDate() < d.getDate()) months -= 1;
  if (months < 0) { years -= 1; months += 12; }
  if (years <= 0 && months <= 0) return 'Less than a month';
  if (years <= 0) return `${months} month${months === 1 ? '' : 's'}`;
  if (months <= 0) return `${years} year${years === 1 ? '' : 's'}`;
  return `${years} year${years === 1 ? '' : 's'} ${months} month${months === 1 ? '' : 's'}`;
}
